module.exports = __webpack_public_path__ + "116f300a4e51d885885102778a3a1a89.svg";